import CollapsibleBoxLayout from './CollapsibleBoxLayout';

export { CollapsibleBoxLayout as default };
